import store from '@/store'
import { cloneDeep, toArray, find } from 'lodash'
import Sortable from 'sortablejs'
// helpers
import eventBus from '@/helpers/event-bus'
import utils from '@/helpers/utils/index.js'
// services
import db from '@/services/db'

export default {
  'click-outside': {
    bind(el, binding, vNode) {
      // Provided expression must evaluate to a function.
      if (typeof binding.value !== 'function') {
        const compName = vNode.context.name
        let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
        if (compName) {
          warn += `Found in component '${compName}'`
        }
        console.warn(warn)
      }

      // Define Handler and cache it on the element
      const bubble = binding.modifiers.bubble

      const handler = e => {
        if (bubble || (!el.contains(e.target) && el !== e.target)) {
          binding.value(e)
        }
      }

      el.__vueClickOutside__ = handler

      // add Event Listeners
      document.addEventListener('click', handler)
    },
    unbind(el, binding) {
      // Remove Event Listeners
      document.removeEventListener('click', el.__vueClickOutside__)
      el.__vueClickOutside__ = null
    },
  },
  'data-select': {
    bind(el, binding, { context }) {
      const dInst = context.$instByClass(context, 'dashboard-component')
  
      if ($(el).hasClass('vue-codemirror')) {
        setTimeout(() => {
          const editorEl = $(el)
            .find('> .CodeMirror')
            .get(0)
          const codemirror = editorEl.CodeMirror
  
          codemirror.on('contextmenu', function(inst, event) {
            event.preventDefault()
  
            dInst.$refs.ctxMenuDataSelect.show({
              event,
              curPos: codemirror.getCursor(),
              el: editorEl,
            })
          })
        })
      } else {
        $(el).contextmenu(function(event) {
          event.preventDefault()
  
          const start = $(el).prop('selectionStart')
          const line = el.value.substr(0, el.selectionStart).split('\n').length
  
          dInst.$refs.ctxMenuDataSelect.show({
            event,
            curPos: { start, line },
            el: event.target,
          })
        })
      }
    },
  },
  update: {
    bind(el, binding, vnode) {
      var b = binding
      console.log(el)
      console.log(binding)
      console.log(vnode)
      //console.log(oldVnode)
      var inputHandler = function(e, b) {}
      el.addEventListener('blur', inputHandler)
      el.onblur = function() {
        el.classList.add('form__blurred')
      }
    },
  },
  'dg-draggable-th': {
    inserted(el, binding, a) {
      Sortable.create(el, {
        draggable: '.draggable',
        onEnd(e) {
          let meta = cloneDeep(eval(`a.context.${binding.expression}`))

          if (e.oldIndex === e.newIndex) return

          const oldIdx = e.oldIndex - 2
          const newIdx = e.newIndex - 2

          for (let cellKey in meta) {
            meta[cellKey].key = cellKey
          }

          meta = toArray(meta)

          const itemToMove = meta.splice(oldIdx, 1)[0]
          meta.splice(newIdx, 0, itemToMove)

          const resultMeta = {}

          for (let idx in meta) {
            if (idx === 'rmIndex') continue

            const item = meta[idx]
            item.order = idx
            resultMeta[item.key] = item
            delete resultMeta[item.key].key
          }

          a.context.$emit('dgColumnOrderChange', resultMeta)
        },
      })
    },
  },
  sortable: {
    inserted(el, binding, vm) {
      Sortable.create(el, {
        draggable: '.draggable',
        onEnd(e) {
          const method = binding.value.method
          const args = binding.value.args || {}

          vm.context[method]({ el, ...args })
        },
      })
    },
  },
  edit: {
    bind(el, binding) {
      $(el).css('position', 'relative')
      $(el).mouseenter(() => {
        $(el)
          .find('> .props-editor__edit-btn')
          .css('display', 'block')
      })
      $(el).mouseleave(() => {
        $(el)
          .find('> .props-editor__edit-btn')
          .css('display', 'none')
      })
      const editBtn = $(
        '<a href="#" class="props-editor__edit-btn"><i class="fa fa-cog" /></a>'
      )
      $(el).append(editBtn)

      $(editBtn).on('click', function(e) {
        e.preventDefault()

        const data = {
          name: binding.value,
          offset: {
            left: e.clientX,
            top: e.clientY,
          },
        }

        eventBus.$emit('propsEditorShow', data)
      })
    },
  },
  draggable: {
    inserted(el, { value }) {
      new Sortable(el, {
        animation: 150,
        ghostClass: 'bg-light',
        ...(value || {}),
      })
    },
  },
  'back-to-default': {
    bind(el, binding) {
      backToDefaultAssignEl(el, binding)
    },
    update(el, binding) {
      backToDefaultAssignEl(el, binding)
    },
  },
}

function backToDefaultAssignEl(el, binding) {
  $(el)
    .find('> ._backToDefaultTrigger')
    .remove()

  if (!binding.value) return

  const control1 = binding.value[0]
  const control2 = binding.value[1]
  const prop = binding.value[2]
  const cb = binding.value[3]

  if (!control1 || !control2 || !prop || !cb) return
  if (control2[prop] === control1[prop]) return

  const resetBtn = $(`
    <a
      href="#"
      class="_backToDefaultTrigger"
      data-toggle="tooltip"
      title="Back to default value"
    >
      <i class="fa fa-undo" aria-hidden="true"></i>
    </a>
  `)

  $(resetBtn).click(function(e) {
    e.preventDefault()
    $('#' + $(resetBtn).attr('aria-describedby')).remove()

    cb(prop, control1[prop])
  })

  $(el).append(resetBtn)
  $(resetBtn).tooltip()
}
